<template>
	<div class="totop">
		<div class="topItem" @click="tofeedback" >
			<div><i class="el-icon-edit-outline"></i></div>
			<div>反馈</div>
		</div>
		<div class="topItem" @click="totop">
			<div><i class="el-icon-arrow-up"></i></div>
			<div>TOP</div>
		</div>
		<div class="feedback" v-show='feedback'>
			<div class="feedback_cont">
				<i class="feedback_close el-icon-close" @click="cancelBack"></i>
				<el-form :model="form" :rules='rules' ref='addform'>
					<div class="feedback_title">意见反馈</div>
					<div class="feedback_desc">欢迎您对我们提出宝贵的意见和建议</div>
					<div class="feedback_item">
						<div class="feedback_label">反馈类型：</div>
						<el-form-item prop='type'>
							<div class="feedback_input">
								<div :class="form.type==item?'feedback_check active':'feedback_check'" @click="optionitem(item)" v-for='(item,index) in feedtypes'>{{item}}</div>
							</div>
						</el-form-item>
					</div>
					<div class="feedback_item">
						<div class="feedback_label">反馈内容：</div>
						<el-form-item prop='description'>
							<div class="feedback_input">
								<div class="feedback_textare">
									<textarea v-model='form.description' placeholder="请输入您对我们的意见或建议"></textarea>
								</div>
							</div>
						</el-form-item>
					</div>
					<div class="feedback_item">
						<div class="feedback_label">手机号码：</div>
						<el-form-item prop='contact'>
							<div class="feedback_input">
								<div class="feedback_text">
									<input type="text" v-model='form.contact' placeholder="请输入您的手机号码" />
								</div>
							</div>
						</el-form-item>
					</div>
				</el-form>
				<div class="feedback_buttons">
					<div class="feedback_button" @click="checkBack">
						<img src="@/images/zy_button.png" class="feedback_back" />
						<span>发送</span>
					</div>
					<div class="feedback_button" @click="cancelBack">
						<img src="@/images/zy_button_cancel.png" class="feedback_back" />
						<span>取消</span>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import { coupleBackSave } from "@/api/feedback.js"
	export default {
		name: 'totop',
		data() {
			var validatorphone = (rule, value, callback) => {
				let reg = /^1[3456789]\d{9}$/;
				if(!reg.test(value)) {
					callback(new Error('请输入正确的手机号码'))
				} else {
					callback()
				}
			};
			return {
				dataloading: false,
				feedtypes: ['使用问题', '产品功能', '页面设计', '出现Bug'],
				feedback: false,
				isMoving: false,
				backPosition: 0,
				form: {
					type: "",
					contact: "",
					description: "",
				},
				rules: {
					type: [{
						required: true,
						message: '请选择反馈类型',
						trigger: 'blur'
					}],
					contact: [{
							required: true,
							message: '请输入手机号码',
							trigger: 'blur'
						},
						{
							validator: validatorphone,
							trigger: 'blur'
						}
					],
					description: [{
						required: true,
						message: '请输入反馈内容',
						trigger: 'blur'
					}],

				},
			}
		},
		created() {

		},
		mounted() {

		},
		methods: {
			tofeedback() {
				this.feedback = true
			},
			cancelBack() {
				this.feedback = false
			},
			checkBack() {
				if(!this.dataloading) {
					this.dataloading = true;
					setTimeout(_ => {
						this.dataloading = false;
					}, 1000)
					this.$refs.addform.validate((valid) => {
						if(valid) {
							coupleBackSave({
								type: this.form.type,
								description: this.form.description,
								contact: this.form.contact,
							}).then(async res => {
								if(res.code == "0") {
									this.$message({
										message: '反馈成功',
										type: 'success'
									});
									this.feedback = false
									this.resetForm();
								} else {
									this.$message({
										message: res.msg,
										type: 'error'
									});
								}
							});
						}
					})
				}
			},
			resetForm(){
				this.form= {
					type: "",
					contact: "",
					description: "",
				}
			},
			optionitem(item) {
				this.form.type = item
			},
			totop() {
				if(this.isMoving) {
					return
				}
				const start = window.pageYOffset;
				let i = 0
				this.isMoving = true
				this.interval = setInterval(() => {
					const next = Math.floor(this.easeInOutQuad(10 * i, start, -start, 500))
					if(next <= this.backPosition) {
						window.scrollTo(0, this.backPosition)
						clearInterval(this.interval)
						this.isMoving = false
					} else {
						window.scrollTo(0, next)
					}
					i++
				}, 16.7)
			},
			easeInOutQuad(t, b, c, d) {
				if((t /= d / 2) < 1) return c / 2 * t * t + b
				return -c / 2 * (--t * (t - 2) - 1) + b
			}
		},
	}
</script>